export default __webpack_public_path__ + "static/TacticalUrbanismAndPedestrianPlazas-83c2ee5bbce4475ffedea95a4282d6a9.jpg";